import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "../css/CustomerCard.css";
import PhoneIcon from "../assets/Icons/PhoneIcons";
import MailIcons from "../assets/Icons/MailIcons";
import React from "react";
import { motion } from "framer-motion";
import api from "../api"; // ✅ centralized API

const BASE_URL = api.defaults.baseURL.replace("/api/auth", "");
// strips `/api/auth` → gives "http://192.168.1.12:8000"

const CustomerCard = ({
  profile_image,
  name,
  petsCount,
  phone,
  email,
  subscribed,
  status, // ✅ take from backend
  onDelete,
  onStatusChange,
  id,
}) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/customer/${id}`, {
      state: {
        id,
        profile_image,
        name,
        petsCount,
        phone,
        email,
        subscribed,
        status,
      },
    });
  };

  const stopPropagation = (e) => e.stopPropagation();

  return (
    <motion.div
      className="customer-card"
      onClick={handleCardClick}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ type: "spring", stiffness: 120, damping: 15 }}
      whileHover={{ scale: 1.06, boxShadow: "0 8px 20px rgba(0,0,0,0.4)" }}
    >
      <motion.div
        className={`status-badge ${subscribed ? "subscribed" : "unsubscribed"}`}
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
      >
        {subscribed ? "Subscribed User" : "Unsubscribed User"}
      </motion.div>

      <div className="card-content">
        <motion.img
          src={
            profile_image
              ? `${BASE_URL}${profile_image}` // ✅ backend gives /media/...
              : "/default-avatar.png"
          }
          alt={name}
          className="avatar"
          whileHover={{ scale: 1.1 }}
          transition={{ type: "spring", stiffness: 200 }}
        />

        <div className="details">
          <h3 className="name">{name}</h3>
          <p className="info">
            No Of Pets They Have: <strong>{petsCount}</strong>
          </p>
          <p className="info">
            <PhoneIcon className="info-icon" />
            {phone}
          </p>
          <p className="info">
            <MailIcons className="info-icon" />
            {email}
          </p>

          <div className="card-actions" onClick={stopPropagation}>
            <motion.button
              className={`btn active-btn ${
                status === "active" ? "selected" : ""
              }`}
              onClick={() => onStatusChange(id, "active")}
            >
              Active
            </motion.button>

            <motion.button
              className={`btn inactive-btn ${
                status === "suspended" ? "selected" : ""
              }`}
              onClick={() => onStatusChange(id, "inactive")}
            >
              In Active
            </motion.button>

            <motion.div
              className="delete-icon"
              onClick={onDelete}
              whileHover={{ scale: 1.2, rotate: 10 }}
              whileTap={{ scale: 0.8 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zm2-4h2V8H9zm4 0h2V8h-2z"
                />
              </svg>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

CustomerCard.propTypes = {
  profile_image: PropTypes.string,
  name: PropTypes.string.isRequired,
  petsCount: PropTypes.number.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  subscribed: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired, // ✅ required now
  onDelete: PropTypes.func,
  onStatusChange: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

CustomerCard.defaultProps = {
  onDelete: () => {},
  onStatusChange: () => {},
};

export default CustomerCard;
